<template>
  <v-container grid-list-md>
    <v-form v-model="valid">

      <v-card>
        <v-card-title><h2>Create new User</h2></v-card-title>

        <v-card-text>
          <v-layout>
            <v-flex xs12>
              <v-radio-group
                v-model="userData.userRoleScope"
                error-messages="Choose Scope"
                :error="$v.userData.userRoleScope.$error"
                :hideDetails="!$v.userData.userRoleScope.$error"
              >
                <v-radio
                  v-for="item in userScopes"
                  :key="item"
                  :label="`${item}`"
                  :value="`${item}RoleScope`"
                ></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>

          <v-layout wrap row pl-3>
            <v-flex xs3>
              <content-field
                label="Email"
                type="email"
                v-model="userData.email"
                @blur="$v.userData.email.$touch()"
                :error="$v.userData.email"
              />
            </v-flex>
            <v-flex xs3>
              <content-field
                label="Username"
                type="text"
                v-model="userData.userName"
                @blur="$v.userData.userName.$touch()"
                :error="$v.userData.userName"
              />
            </v-flex>
          </v-layout>

          <v-layout wrap row pl-3>
            <v-flex xs4 md4 lg1 xl1>
              <v-btn @click="sendCreateUserRequest"
                     color="success"
              >
                Create User
              </v-btn>
            </v-flex>

          </v-layout>
        </v-card-text>

      </v-card>

    </v-form>
  </v-container>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import stringCapitalize from '@/utils/helpers'
  import ContentField from '@/components/shared/ContentField'
  import { required, maxLength, email } from 'vuelidate/lib/validators'
  import { lte, not } from 'ramda'
  import ECheckboxes from 'shared/ECheckboxes'
  import mixins from '@/utils/mixins'
  import roleScopes from '@/utils/roleScopes'

  export default {
    name: "CreateUser",
    mixins: [mixins.isWriteAvailable],
    components: {
      ContentField,
      ECheckboxes
    },
    props: {
      userScopes: {
        type: Array
      }
    },
    data (){
      return {
        userData: {
          email: '',
          userName: '',
          userRoleScope: ''
        },
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'master'
      }
    },
    computed: {
      ...mapGetters([
        'getIsManager',
        'getIsMaster'
      ]),
    },
    methods: {
      ...mapActions([
        'createUser',
        'showResultSuccessMessage',
        'showResultErrorMessage',
        'fetchScopesList'
      ]),
      stringCapitalize,
      async sendCreateUserRequest () {
        try {
          this.$v.$touch()
          if (this.$v.$invalid) return
          let config = {
            email: this.userData.email,
            userName: this.userData.userName,
            scopes: roleScopes[this.userData.userRoleScope]
          }
          await this.createUser(config)
          this.$v.$reset()
          this.checkedScopes = ['admin']
          this.userData = {
            email: '',
            userName: '',
            userRoleScope: ''
          }
          this.showResultSuccessMessage('User was created successfully')
          this.$emit('fetchUsersToTable')
        } catch (err) {
          this.showResultErrorMessage(`Failed on create user`)
        }
      }
    },
    validations: {
      userData: {
        email: {
          required,
          email,
          maxLength: maxLength(35)
        },
        userName: {
          required,
          maxLength: maxLength(20)
        },
        userRoleScope: {
          required
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
/deep/ .input-group {
  width: 200px;
  display: inline-block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Users/createUser.vue